export default function(spec, scope) {
  return spec && spec.signal ? scope.signalRef(spec.signal)
    : spec === false ? false
    : true;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-parser/src/parsers/marks/interactive.js
// module id = 910
// module chunks = 0